import {UserEmotion} from "../../schema";

export const UserEmotionEmoji = {
  [UserEmotion.NEUTRAL]: "🙂",
  [UserEmotion.JOY]: "😀",
  [UserEmotion.ENTHUSIASM]: "🧐",
  [UserEmotion.ANGER]: "😡",
  [UserEmotion.GUILT]: "😔",
  [UserEmotion.SHAME]: "😳",
  [UserEmotion.FEAR]: "😱",
  [UserEmotion.DISGUST]: "🤢",
  [UserEmotion.SADNESS]: "😢",
  [UserEmotion.SURPRISE]: "😮",
};
